import React from 'react'
import MuiSnackbar from '@material-ui/core/Snackbar'
import Slide, { SlideProps } from '@material-ui/core/Slide'

interface SnackbarProps {
  message: React.ReactNode
  isOpen: boolean
  handleClose: () => void
}

function TransitionUp(props: Omit<SlideProps, 'direction'>) {
  return <Slide {...props} direction="up" />
}

const Snackbar: React.FC<SnackbarProps> = ({ message, isOpen, handleClose }) => {
  return (
    <MuiSnackbar
      open={isOpen}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      message={message}
      TransitionComponent={TransitionUp}
    />
  )
}

export { Snackbar }
